export default __webpack_public_path__ + "static/media/button-small-pressed@3x.427481ca.png";